<template>
  <div v-if="propNoticias.length > 0"> 
    <h1 style="font-size: xx-large; line-height: 35px; font-weight: bold;" :style="{ color: $ajustes.colorTexto2 }">
      NOTICIAS Y NOVEDADES</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">Conoce
      nuestros eventos mas importantes</h1>
    <div class="slide-group-wrapper" style="position: relative;">
      <v-slide-group show-arrows v-model="slide" class=" pa-0 ma-0" style="overflow-x: hidden;">
        <v-slide-item v-for="noticia in noticiasDestacadas" :key="noticia.id" :value="noticia.id">
          <div class="ma-3">
            <noticia :propNoticia="noticia" />
          </div>
        </v-slide-item>
      </v-slide-group>
    </div>
    <div style="width: 100%;" class="center mt-4 mb-5">
      <v-btn class="pa-6" :color="$ajustes.colorTexto2" :style="{ color: $ajustes.colorTexto1 }"
        @click="$router.push({ name: 'Noticias' })">
        <h1>VER TODAS LAS NOTICIAS</h1>
      </v-btn>
    </div> 
  </div>
</template>
<script>
import noticia from "@/components/template/noticia";
export default {
  components: {
    noticia
  },
    props: {
    propNoticias: { type: Array },
  },
  data() {
    return {
      noticias: [],
      slide: null,
    };
  },
  mounted() {
     this.autoSlide();
  },

  created() { },
  computed: {
     noticiasDestacadas() {
      return this.propNoticias.filter(noticia => noticia.destacado & noticia.habilitado );
    }
  },
  methods: {
    autoSlide() {
      setInterval(() => {
        const currentIndex = this.propNoticias.findIndex(n => n.id === this.slide);
        const nextIndex = (currentIndex + 1) % (this.propNoticias.length);
        this.slide = this.propNoticias[nextIndex].id;
      }, 4000);
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.slide-group-wrapper>>>.v-slide-group__prev,
.slide-group-wrapper>>>.v-slide-group__next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.slide-group-wrapper>>>.v-slide-group__prev {
  left: 1px;
}

.slide-group-wrapper>>>.v-slide-group__next {
  right: 1px;
}
</style>
